<template>
  <TheProductDetails
    v-if="Object.keys(product).length > 0"
    :add-to-cart-url="addToCartUrl"
    :context="context"
    :loading="loading"
    :product="product"
    @zoomopen="isZoomOpen = true"
    @zoomclose="isZoomOpen = false"
  />
</template>

<script>
import { mapState } from 'vuex';
import getFrontConfig from '../../common/getFrontConfig';
import EventBusConfig from '../config/eventBusConfig';
import { types } from '../store';
import TheProductDetails from './TheProductDetails.vue';
import pageDataMixin from '../mixins/pageDataMixin';
import { PAGE_TYPES } from '../../../../../config/analytics';

const FRONT_CONFIG = getFrontConfig();

export default {
  name: 'ThePDP',

  components: {
    TheProductDetails,
  },

  mixins: [pageDataMixin],

  // Avoid browser navigating back if zoom is open and close it instead
  beforeRouteLeave(to, from, next) {
    if (this.isZoomOpen) {
      next(false);
    } else {
      next();
    }
  },

  data: () => ({
    context: FRONT_CONFIG.vue.TheProductDetails.context.routerView,
    isZoomOpen: false,
  }),

  computed: {
    ...mapState({
      product: (state) => state.product.details?.product || {},
      addToCartUrl: (state) => state.product.details?.addToCartUrl ?? '',
      loading: (state) => state.product.loading,
    }),
  },

  watch: {
    product() {
      this.pageTitle = this.product?.productName || '';
    },
  },

  mounted() {
    this.pageType = PAGE_TYPES.product;
    this.$eventBus.$on(
      EventBusConfig.commands.TheProductDetails.updateProduct,
      this.handleUpdateProductCommand
    );
  },

  beforeDestroy() {
    this.$eventBus.$off(
      EventBusConfig.commands.TheProductDetails.updateProduct,
      this.handleUpdateProductCommand
    );
  },

  methods: {
    handleUpdateProductCommand({ product, container }) {
      if (container.dataset.context === this.context) {
        this.$store.commit(types.product.updateWithVariation, product);
      }
    },
  },
};
</script>
